// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mt-z","response":"nt-z","error":"ot-z","disabled":"pt-z","buttons":"qt-z","feedbackQuestionSection":"rt-z","yesNoWrapper":"st-z"};